// :cow: Cosmose CONFIDENTIAL :iso:
import { Pipe, PipeTransform } from '@angular/core';
import { LocationPreference } from '../services/location-preferences.response';
import { SankeyData } from '@coa/app/shared/sankey-diagram/components/models/sankeyData';

@Pipe({
  name: 'sankey',
})
export class SankeyPipe implements PipeTransform {

  transform(locationPreferences: LocationPreference[]): SankeyData[] {
    return locationPreferences && locationPreferences.length > 0
      ? locationPreferences
        .map((element) => ({
          brandName: element.locationName,
          referenceGroupVisitorsPercentage: element.clientLocationVisitorsPercentage,
        }))
      : [];
  }

}
